<template>
  <v-container>
    <validation-observer v-slot="{ valid }">
      <base-request-material-wizard
        v-model="tab"
        :available-steps="availableSteps"
        :items="tabs"
        class="mx-auto"
        @click:next="sendRequestSlack(valid)"
        @click:prev="$emit('click:prev')"
        :loading="loading"
      >
        <v-tab-item class="pb-1">
          <form>
            <v-row no-gutters class="mb-0 pb-0">
              <v-col cols="12">
                  <validation-provider v-slot="{ errors }" rules="required|min:3|max:100">
                    <v-text-field
                      v-model="nome"
                      label="Nome"
                      outlined
                      :disabled="loading"
                      :error-messages="errors"
                    />
                  </validation-provider>
              </v-col>
            </v-row>
            <v-row no-gutters class="mb-0 pb-0">
              <v-col cols="12">
                  <validation-provider v-slot="{ errors }" rules="required|min:16|max:16">
                    <v-text-field
                      v-model="telefone"
                      label="Telefone"
                      hint="Formato (##) # ####-####"
                      outlined
                      type="tel"
                      v-mask="'(##) # ####-####'"
                      :disabled="loading"
                      :error-messages="errors"
                    />
                  </validation-provider>
              </v-col>
            </v-row>
            <v-row no-gutters class="mb-0 pb-0">
              <v-col cols="12">
                  <validation-provider v-slot="{ errors }" rules="required|max:100">
                    <v-text-field
                      v-model="empresa"
                      label="Empresa de Atuação"
                      outlined
                      :disabled="loading"
                      :error-messages="errors"
                    />
                  </validation-provider>
              </v-col>
            </v-row>
            <v-row no-gutters class="mb-0 pb-0">
              <v-col cols="12">
                  <validation-provider v-slot="{ errors }" rules="required|email|max:100">
                    <v-text-field
                      v-model="email"
                      label="E-mail"
                      type="email"
                      outlined
                      :disabled="loading"
                      :error-messages="errors"
                    />
                  </validation-provider>
              </v-col>
            </v-row>
            <v-row no-gutters class="mb-n10 pb-0">
              <v-col cols="12">
                  <validation-provider v-slot="{ errors }" rules="required">
                    <v-select
                      value="Ferramentas Gratuitas"
                      label="Selecione a Empresa (Para Liberação de Acesso)"
                      no-gutters
                      outlined
                      :items="['Ferramentas Gratuitas']"
                      :disabled="loading"
                      :error-messages="errors"
                    />
                  </validation-provider>
              </v-col>
            </v-row>
          </form>
        </v-tab-item>
      </base-request-material-wizard>
    </validation-observer>
  </v-container>
</template>

<script>
import UsuariosService from '@/services/UsuariosService.js';

export default {
  components: {
    BaseRequestMaterialWizard: () => import("@/components/login/base/BaseRequestMaterialWizard")
  },

  created() {
    this.clearInputs();
  },

  data: () => ({
    tab: 0,
    tabs: ['Solicitar Acesso'],
    nome: null,
    telefone: null,
    empresa: null,
    email: null,
    loading: false
  }),

  computed: {
    availableSteps () {
      const steps = [0];
      return steps;
    }
  },

  methods: {
    clearInputs() {
      this.nome = null;
      this.telefone = null;
      this.empresa = null;
      this.email = null;
    },

    sendRequestSlack (id) {
      this.loading = true;

      this.$store.dispatch('setEmpresa', 'lite');

      const user = {
        nome: this.nome,
        telefone: this.telefone,
        empresa: this.empresa,
        email: this.email
      };
      
      UsuariosService.sendRequestSlackHexaLite(user)
      .then(() => {
        this.$toast.success('Solicitação de Acesso Realizada - <b>(em breve você receberá um e-mail com os dados para acesso)</b>.', '',{ position:'topRight', timeout: 7000 });
        this.clearInputs();
        this.$emit('click:prev');
      })
      .catch(error => {
        console.log(error);
        this.$toast.error('Erro ao solicitar acesso.', '',{position:'topRight'});
      })
      .finally(() => {
        this.$store.dispatch('setEmpresa', '');
        this.loading = false;
      });
    },
  }
}
</script>

<style lang="sass">
  .v-card.v-card.v-card--account
    border-color: currentColor
    border-width: 4px

    .v-icon
      color: inherit

  .v-card--account,
  .v-card--account:before
    border-radius: 50%

</style>